import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import AuthImage from "@/components/AuthImage";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Search } from "lucide-react";

export default function MemberPicker({ open, onClose, frigate, onDone, title, single, needName }) {
  const { user } = useAuth();
  const [members, setMembers] = useState([]);
  const [q, setQ] = useState("");
  const [sel, setSel] = useState([]);
  const [name, setName] = useState("");
  useEffect(() => { if (open) { api.get("/members", { params: frigate ? { frigate } : {} }).then((r) => setMembers(r.data.members.filter((m) => m.id !== user?.id))); setSel([]); setName(""); setQ(""); } }, [open, frigate, user?.id]);
  const toggle = (id) => setSel((s) => single ? [id] : s.includes(id) ? s.filter((x) => x !== id) : [...s, id]);
  const list = members.filter((m) => m.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass" data-testid="member-picker">
        <DialogHeader><DialogTitle className="font-display">{title}</DialogTitle></DialogHeader>
        {needName && <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Group name" data-testid="group-name-input" />}
        <div className="relative"><Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" /><Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search brothers…" className="pl-9" data-testid="picker-search" /></div>
        <div className="max-h-72 space-y-1 overflow-y-auto">
          {list.map((m) => (
            <label key={m.id} className="flex cursor-pointer items-center gap-3 rounded-lg px-2 py-1.5 hover:bg-secondary" data-testid={`pick-${m.id}`}>
              <Checkbox checked={sel.includes(m.id)} onCheckedChange={() => toggle(m.id)} />
              <Avatar className="h-7 w-7">{m.photo_path ? <AuthImage path={m.photo_path} className="h-7 w-7 rounded-full object-cover" /> : <AvatarFallback className="text-[0.6rem]">{m.name[0]}</AvatarFallback>}</Avatar>
              <span className="text-sm">{m.name}</span><span className="ml-auto text-xs text-muted-foreground">{m.position}{m.frigate ? ` · ${m.frigate}` : ""}</span>
            </label>
          ))}
        </div>
        <DialogFooter><Button onClick={() => onDone(sel, name)} disabled={sel.length === 0 || (needName && !name.trim())} className="bg-[hsl(var(--gold))] text-[hsl(var(--primary-foreground))]" data-testid="picker-confirm">{single ? "Open chat" : "Create group"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
